import React from 'react'
import './contact.css'
import Footer from '../../components/Footer/Footer';
import { useEffect,useRef } from 'react';
import emailjs from '@emailjs/browser';

export const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_x3av23e', 'template_v9j2d3f', form.current, 'lB0-TCY2ZiLHZG0Qd')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
      const handleSubmitBTNClick={
          
      }

    useEffect(() => {
        window.scrollTo(0, 0)
    
      }, [])

  return (
    <div className='contactPage'>
        
        <div className='contactPageHero'>
            <Footer />
      </div>
      <div className="devider">
      </div>
        <div id='contactForm' className="contactForm">
            <div id='left' className="left">
                <p className="contactFormDes">
                    HAVE SOMETHING IN MIND?
                </p>
                <p id='contactFormTitle' className="contactFormTitle">
                    TELL US <br /> EVERYTHING
                </p>
                <p className="contactFormDesBottom">
                    *or ALMOST
                </p>
            </div>
            <div id='right' className="right">
                <form action="" ref={form} onSubmit={sendEmail}>
                    <input type="email" name="user_email"  placeholder='name@example.com'/>
                    <input type="text" name="user_name"  placeholder='name'/>
                    <textarea type="text" name="message" placeholder='your messeage'/>
                    <button type='submit' onClick={handleSubmitBTNClick}>IT'S GOING</button>
                </form>
            </div>
        </div>
    </div>
  )
}
